module.exports = __webpack_public_path__ + "static/card5-218544624359a8990316a226beb3a028.png";